/* Hona 2026-11-02: free starter kit is limited to 1 per order. The theme adds the kit on every subscription
   add-to-cart and Shopify merges identical lines, so repeat adds (or the cart +/- control) pushed the kit to qty 2+.
   After any cart add/change/update, and on page load, clamp the kit line(s) to a single unit. */
(function () {
  var KIT_SKU = 'HFG0005';
  var origFetch = window.fetch;
  if (!origFetch || window.__honaKitCap) return;
  window.__honaKitCap = true;

  var running = false, again = false, timer = null;

  function isKit(item) {
    return item && item.sku === KIT_SKU;
  }

  function enforce() {
    if (running) { again = true; return; }
    running = true;
    origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var kits = (cart.items || []).filter(isKit);
        var updates = {};
        kits.forEach(function (item, i) {
          if (i === 0) {
            if (item.quantity > 1) updates[item.key] = 1;
          } else {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return;
        return origFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 250);
  }

  /* watch the theme's and landing pages' own cart calls without changing them */
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  if (document.readyState !== 'loading') schedule();
})();
